/**
 * Available Apps Thunks
 * Async thunks for fetching the set of apps/tools visible to the current user.
 *
 * Task 32 — Requirements: 5.5
 */

import { createAsyncThunk } from '@reduxjs/toolkit';
import { sysAppService } from '../../services/api/sysAppService';

/**
 * Fetches the list of apps and tools available to the current authenticated user.
 * Calls GET /api/v1/sysapps/available via the sysAppService.
 * Module-classified entries are excluded by the backend.
 */
export const fetchAvailableApps = createAsyncThunk(
  'availableApps/fetchAvailableApps',
  async (_, { rejectWithValue }) => {
    try {
      return await sysAppService.getAvailableApps();
    } catch (error: any) {
      return rejectWithValue(error.message ?? 'Failed to fetch available apps');
    }
  }
);
